import React from "react"
import {
  RealEstateProperty,
  CarProperty
} from "./PropertyDetailsView/worksheetTypes"

export const propertyTypes = {
  realestate: {
    label: "Real Estate",
    icon: "home",
    view: RealEstateProperty,
    description: (
      <span>
        Real estate property you own, like a house or condo that you live in or
        rent out.
      </span>
    ),
    category: "realestate"
  },
  car: {
    label: "Car",
    icon: "car",
    view: CarProperty,
    description: <span>Car property you own.</span>,
    category: "car"
  }
}

export const propertyCategoryLabels = new Map([
  ["realestate", "Real Estate"],
  ["car", "Car"]
])
